import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [Stopwatch, AnimatedStopwatch] = createIcon({
  name: 'Stopwatch',
  getIcon: (props) => (
    <Svg viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M5.50001 2C5.50001 1.724 5.72401 1.5 6.00001 1.5H9.33334C9.60934 1.5 9.83334 1.724 9.83334 2C9.83334 2.276 9.60934 2.5 9.33334 2.5H6.00001C5.72401 2.5 5.50001 2.276 5.50001 2ZM12.6667 9C12.6667 11.7613 10.428 14 7.66667 14C4.90534 14 2.66667 11.7613 2.66667 9C2.66667 6.23867 4.90534 4 7.66667 4C8.78201 4 9.80798 4.36932 10.64 4.98665L11.6467 3.97998C11.84 3.78665 12.16 3.78665 12.3534 3.97998C12.5467 4.17331 12.5467 4.49335 12.3534 4.68669L11.3801 5.65999C12.1774 6.54599 12.6667 7.71467 12.6667 9ZM9.29997 9.60002L8.16667 8.75V6.66667C8.16667 6.39067 7.94267 6.16667 7.66667 6.16667C7.39067 6.16667 7.16667 6.39067 7.16667 6.66667V9C7.16667 9.15733 7.2407 9.30532 7.3667 9.39998L8.70004 10.4C8.79004 10.4673 8.89535 10.5 8.99935 10.5C9.15202 10.5 9.30207 10.4306 9.40007 10.3C9.56607 10.0793 9.52064 9.76535 9.29997 9.60002Z"
        fill={'currentColor' ?? '#FF37C7'}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </Svg>
  ),
  defaultFill: '#FF37C7',
})
